import React from 'react';
import PropTypes from 'prop-types';
import { StandardBody } from 'web-ui-components/lib/typography/body';
import { Row, Column } from 'web-ui-components/lib/global/layout';
import withContent from '../../../containers/withContent';
import PageNavigation from '../../../sharedComponents/PageNavigation/PageNavigation';
import pageContent, { contentPropTypes } from '../bacs/importedPayments.content';
import { EnhancedBatchProgressTakeover } from '../../../sharedComponents/BatchProgressTakeover/BatchProgressTakeover';

const BacsUploadFooter = ({ hasApiCallInProgress, handleContinue, handleCancel, content, isBatchLimitExceeded }) => {
	const { footerText } = content;
	return (
		<div>
			<Row className="u-margin-top-2">
				<Column md={12}>
					<StandardBody isFlush>{footerText}</StandardBody>
				</Column>
			</Row>
			<EnhancedBatchProgressTakeover contentKey="checkPayees" />
			<Row>
				<Column md={12}>
					<PageNavigation
						showLoading={hasApiCallInProgress}
						handleContinue={handleContinue}
						showContinue
						showBack
						enableBack
						secondaryButtonText="Cancel"
						handleBack={handleCancel}
						enableContinue={!hasApiCallInProgress && !isBatchLimitExceeded}
					/>
				</Column>
			</Row>
		</div>
	);
};

BacsUploadFooter.propTypes = {
	hasApiCallInProgress: PropTypes.boolean,
	handleContinue: PropTypes.func,
	handleCancel: PropTypes.func,
	content: PropTypes.shape(contentPropTypes).isRequired,
	isBatchLimitExceeded: PropTypes.bool,
};

export const contentWrapper = withContent({ content: pageContent })(BacsUploadFooter);
